'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowWrapper = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _window2 = require('./window.mock');

var _window3 = _interopRequireDefault(_window2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindowWrapper = function () {
  function WindowWrapper() {
    (0, _classCallCheck3.default)(this, WindowWrapper);

    this.reset();
  }

  (0, _createClass3.default)(WindowWrapper, [{
    key: 'windowIsAvailable',
    value: function windowIsAvailable() {
      try {
        return typeof window !== 'undefined';
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.isMock = !this.windowIsAvailable();
      this.window = this.isMock ? _window3.default : window;
      if (this.isMock) {
        this.window.mockInstanceId = Math.floor(Math.random() * 100000);
      }
    }
  }]);
  return WindowWrapper;
}();

var windowWrapper = new WindowWrapper();
var _window = windowWrapper.window;

exports.default = _window;
exports.windowWrapper = windowWrapper;